"use strict";

/* Closest polyfill */
if (!Element.prototype.matches) {Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector}
if (!Element.prototype.closest) { Element.prototype.closest = function(s) { var el = this;
    do {
        if (Element.prototype.matches.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
        return null;
    };
}

// let lastKnownScrollPosition = 0;
// let ticking = false;
// let headerShown = true;

// function checkHeaderPos(scrollPos, goingUp) {
//     if(goingUp && !headerShown) {
//         headerShown = true;
//         document.body.classList.remove('header-hidden');
//     } else if(!goingUp && headerShown && scrollPos > 100) {
//         headerShown = false;
//         document.body.classList.add('header-hidden');
//     }
// }

// document.addEventListener('scroll', function(e) {
//     let goingUp = lastKnownScrollPosition > window.scrollY;
//     lastKnownScrollPosition = window.scrollY;

//     if (!ticking) {
//         window.requestAnimationFrame(function() {
//             checkHeaderPos(lastKnownScrollPosition, goingUp);
//             ticking = false;
//         });

//         ticking = true;
//     }
// });

// function lazyloadImageMarkup(src) {
//     var widths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];
  
//     src = src.split('?');
//     src = src[0].replace(/\.(jpg|png|jpeg|gif)/, '_300x300.$1');
//     var image_srcset = src.replace('_300x300.', '_{width}x.');
//     var _image_srcset = [];
//     for(var i = 0; i < widths.length; i++) {
//       _image_srcset.push(src.replace('_{width}x.', '_'+widths[i]+'x.')+' '+widths[i]+'w');
//     }
  
//     return '<img class="lazyload" src="'+src+'" srcset="'+_image_srcset.join(', ')+'" data-srcset="'+_image_srcset.join(', ')+'" alt="" data-src="'+image_srcset+'">';
// }

function format_money(x) {
    x /= 100;
    return '$' + (x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").replace('.00', ''));
}

if(document.querySelector('.pp_testimonials__swiper')) {
    const swiper = new Swiper('.pp_testimonials__swiper', {
        loop: true,
        autoplay: {
            delay: 4000,
        },
        pagination: {
            el: '.swiper-pagination',
        }
    });
}

if(document.querySelector('.pp_personalization__swiper')) {
    const swiper = new Swiper('.pp_personalization__swiper', {
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 3000,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
}

let mobileMenuActivator = document.querySelector('.mobile-menu__activator');
if(mobileMenuActivator) mobileMenuActivator.addEventListener('click', function(e) {
    e.preventDefault();
    document.body.classList.toggle('mobile-menu-shown');
});

// let cartLink = document.querySelector('.cart-link');
// if(cartLink) cartLink.addEventListener('click', function(e) {
//     e.preventDefault();
//     document.body.classList.add('mini-cart-active');
//     document.body.classList.remove('mobile-menu-shown');
// });

// let cartOverlay = document.querySelector('.mini-cart__overlay');
// if(cartOverlay) cartOverlay.addEventListener('click', function(e) {
//     e.preventDefault();
//     document.body.classList.remove('mini-cart-active');
// });

// let cartClose = document.querySelector('.mini-cart__close');
// if(cartClose) cartClose.addEventListener('click', function(e) {
//     e.preventDefault();
//     document.body.classList.remove('mini-cart-active');
// });

const animateOnLoad = document.querySelectorAll('.animate-on-load');
if(window.self !== window.top) {
    setInterval(function() {
        for(let i = 0; i < animateOnLoad.length; i++) animateOnLoad[i].classList.add('animate-on-load--done');
    }, 1500);
}

if ('IntersectionObserver' in window) {
    let observer = new IntersectionObserver(function(entries) {
        for(let i = 0; i < entries.length; i++) {
            let entry = entries[i];
            if (entry.isIntersecting && entry.intersectionRatio > 0) {
                let delay = parseInt(entry.target.getAttribute('data-animation-delay'));
                setTimeout(function() {
                    entry.target.classList.add('animate-on-load--done');
                }, delay);
            }
        }
    }, { rootMargin: '0px', threshold: 0.5 });

    for(var i = 0; i < animateOnLoad.length; i++) {
        observer.observe(animateOnLoad[i]);
    }
}  else {
    for(let i = 0; i < animateOnLoad.length; i++) animateOnLoad[i].classList.add('animate-on-load--done');
}

const mini_cart_overlay = document.querySelector('.mini-cart__overlay');
if(mini_cart_overlay) mini_cart_overlay.addEventListener('click', function(e) {
    e.preventDefault();
    document.querySelector('.mini-cart').classList.remove('mini-cart--active');
})

document.addEventListener('click', function(e) {
    if(!e.target) return;
    if(e.target.classList.contains('popup__overlay') || e.target.classList.contains('popup__close')) {
        e.preventDefault();
        document.body.classList.remove('popup-active');
        e.target.closest('.popup').classList.remove('popup--active');
    }
});

function removeProduct(keys, callback) {
    let updates = {};
    for(let i = 0; i < keys.length; i++) updates[keys[i]] = 0;

    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            updates: updates
        })
    })
    .then(response => response.json())
    .then(response => {
        if(typeof callback == 'function') callback(response);
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

let kl_trigger = document.querySelector('.klaviyo-bis-trigger');
if(kl_trigger) kl_trigger.addEventListener('click', function(e) {
    setTimeout(function() {
        let fr = document.querySelector('#klaviyo-bis-iframe');
        if(fr) fr.contentWindow.document.querySelector('#variants').value = document.querySelector('#product-select').value;
    }, 50);
});